import { Color, Spacing, Text } from 'zens-storybook'
import React from 'react'
import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'

import { LoggingFailed, LoggingSuccess } from '.'

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  error: {
    marginLeft: Spacing.XS,
    color: Color.darkRed,
  },
})

interface Props extends ViewProps {
  syncFailed?: boolean
}
const Status = (props: Props) => {
  const { style, syncFailed, ...otherProps } = props

  if (syncFailed)
    return (
      <View style={[styles.container, style]} {...otherProps}>
        <LoggingFailed />
        <Text style={styles.error} level={5}>
          <Trans>Sync issue</Trans>
        </Text>
      </View>
    )
  return <LoggingSuccess style={style} {...otherProps} />
}

export default Status
